module.exports = __webpack_public_path__ + "img/Auditors.4f303a69.png";